// TabPanelComponent.js
import React from 'react';
import { Box } from '@mui/material';
import InspectionsCard from './InspectionsCard';
import ViolationsCard from './ViolationsCard';
import {
  violationFields,
  inspectionFields,
} from '../../config/TabConfig';
import { 
  updateViolations,
  updateInspection 
} from '../../services/tabService';

const TabPanel = ({ tabs, data, isEditMode, handleFieldChange }) => {
  return (
    <>
      {tabs.map((tab) => (
        <div
          key={tab}
          className="border-2 border-gray-300 px-4 m-2 rounded-xl shadow-lg"
        >
          <Box>
            {tab === 'callHistory' && (
              <div>
                <p>Placeholder for Call History Card</p>
              </div>
            )}
            {tab === 'dispatchHistory' && (
              <div>
                <p>Placeholder for Dispatch History Card</p>
              </div>
            )}
            {tab === 'invoiceHistory' && (
              <div>
                <p>Placeholder for Invoice History Card</p>
              </div>
            )}
            {tab === 'paymentsHistory' && (
              <div>
                <p>Placeholder for Payments History Card</p>
              </div>
            )}
            {tab === 'proposals' && (
              <div>
                <p>Placeholder for Proposals / Jobs Card</p>
              </div>
            )}
            {tab === 'violations' && (
              <ViolationsCard
                assignedInspections={data.assignedInspections}
                violationFields={violationFields}
                isEditMode={isEditMode}
                updateViolation={updateViolations}
                handleChange={handleFieldChange}
                setViolations={data.setViolations}  // make sure to pass setViolations from parent state
                selectedViolation={data.selectedViolation}
                setSelectedViolation={data.setSelectedViolation}
              />
            )}
            {tab === 'inspections' && (
              <InspectionsCard
                assignedInspections={data.assignedInspections}
                selectedInspection={data.selectedInspection}
                setSelectedInspection={data.setSelectedInspection}
                inspectionFields={inspectionFields}
                handleChange={handleFieldChange}
                isEditMode={isEditMode}
                updateInspection={updateInspection}
              />
            )}
          </Box>
        </div>
      ))}
    </>
  );
};

export default TabPanel;
